import { styled } from "../../../styles";

// Figma's bar uses the saturated colours at 72% opacity; these are the same colours flattened
// onto white, which the legend swatches already use.
const bandColor = {
  veryHigh: { backgroundColor: "#FCDD97" },
  high: { backgroundColor: "#FEECC3" },
  inRange: { backgroundColor: "#87D5A9" },
  low: { backgroundColor: "#E95C75" },
  veryLow: { backgroundColor: "#884D59" },
};

export const Container = styled("div", {
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: "24px",
  marginLeft: "48px",
  marginRight: "48px",

  "@sm": {
    margin: "38px 0 0 22px",
  },
});

export const Bar = styled("div", {
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  width: "96px",
  height: "111px",
});

export const Segment = styled("div", {
  // Keeps a band with very little time in it visible.
  minHeight: "2px",
  cursor: "pointer",

  "&:focus-visible": {
    outline: "2px solid $charcoal",
    outlineOffset: "-2px",
  },

  variants: { band: bandColor },
});

export const Legend = styled("ul", {
  display: "grid",
  gridTemplateRows: "repeat(3, auto)",
  gridAutoFlow: "column",
  columnGap: "24px",
  rowGap: "10px",
  margin: 0,
  padding: 0,
  listStyle: "none",
});

export const LegendItem = styled("li", {
  display: "flex",
  alignItems: "center",
  gap: "8px",

  color: "$gray-90",
  fontFamily: "$openSans",
  fontSize: "12px",
  lineHeight: "16px",
  whiteSpace: "nowrap",
});

export const Swatch = styled("span", {
  flexShrink: 0,
  width: "17px",
  height: "8px",
  borderRadius: "2px",

  variants: { band: bandColor },
});

export const TooltipPosition = styled("div", {
  position: "absolute",
  left: 0,
  bottom: "calc(100% + 8px)",
  zIndex: 10,
  width: "max-content",
  maxWidth: "320px",
  pointerEvents: "none",
});
